/* Kunnie Ratgeber: Inhaltsverzeichnis aus den H2-Überschriften des Artikels (progressive Verbesserung –
   die Überschriften stehen serverseitig im HTML, das Verzeichnis ist nur Komfort). */
(() => {
  const root = document.querySelector('[data-kunnie-article]');
  if (!root) return;
  const content = root.querySelector('[data-article-content]');
  const toc = root.querySelector('[data-article-toc]');
  const list = toc && toc.querySelector('ol');
  if (!content || !toc || !list) return;

  const used = new Set();
  const slug = (text) =>
    text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'abschnitt';

  const headings = Array.from(content.querySelectorAll('h2'));
  if (headings.length < 2) return;

  headings.forEach((h2) => {
    if (!h2.id) {
      let id = slug(h2.textContent || '');
      let n = 2;
      while (used.has(id) || document.getElementById(id)) id = `${slug(h2.textContent || '')}-${n++}`;
      h2.id = id;
    }
    used.add(h2.id);
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${h2.id}`;
    a.textContent = h2.textContent || '';
    li.appendChild(a);
    list.appendChild(li);
  });
  toc.hidden = false;
})();
